module.exports = __webpack_public_path__ + "img/zeileloeschen.1f16f3a.svg";